import { createAction, props } from '@ngrx/store';
import { ScheduleConfig } from '../models/wizard.model';

export const HelpTextChanged = createAction('[Wizard- When]: Toggle Help Text Status');

export const WhenTypeChanged = createAction(
  '[Wizard- When]: Type Changed',
  props<{ whenType: string }>(),
);

export const TimezoneChanged = createAction(
  '[Wizard- When]: Timezone Changed',
  props<{ timezone: string }>(),
);

export const AddSchedule = createAction('[Wizard- When]: Add Schedule');

export const RemoveSchedule = createAction(
  '[Wizard- When]: Remove Schedule',
  props<{ index: number }>(),
);

export const UpdateSchedule = createAction(
  '[Wizard- When]: Update Schedule',
  props<{ index: number; schedule: ScheduleConfig }>(),
);

export const AddOnceOffDate = createAction(
  '[Wizard- When]: Add Once Off Date',
  props<{ dateString: string }>(),
);

export const RemoveOnceOffDate = createAction(
  '[Wizard- When]: Remove Once Off Date',
  props<{ index: number }>(),
);

export const SetPendingOnceOffDate = createAction(
  '[Wizard- When]: Set Pending Once Off Date',
  props<{ date: any }>(),
);
